import React from 'react'
import styles from './AccessTablePopup.module.scss'
import { CourseService } from 'api/services/course';
import { SearchIcon } from 'constants/icons';
import PaginationDropdown from 'components/paginationDropdown';
import AddUsersToContentPopUp from 'containers/AddUsersToContentPopUp/AddUsersToContentPopUp';
import CustomUserComponent from 'components/CustomUserComponent/CustomUserComponent';
import moment from 'moment';
import ContentLoader from 'react-content-loader';


const AccessTablePopup = (
    {
        group,
        onClose,
        accessData
    }:
        {
            group: any
            onClose: any
            accessData: any
        }
) => {

    const [isLoading, setIsLoading] = React.useState<boolean>(true);
    const [data, setData] = React.useState<any>(null);
    const [searchString, setSearchString] = React.useState<string>("");

    React.useEffect(() => {
        if (searchString.length === 0) {
            if (accessData.accessTitle === 'queue') {
                fetchOnQueueDrip();
            } else {
                fetchAccessOnDrip()
            }
        }
    }, [searchString]);

    const fetchOnQueueDrip = (query?: string) => {
        let queryString: string = "";
        if (query) {
            queryString = `?search=${query}`;
        }
        setIsLoading(true);
        CourseService.getInstance()
            .fetchOnQueueDrip(group.id, accessData.courseId, accessData.section.id, queryString)
            .then((response: any) => {
                setData(response.data);
            })
            .catch(() => {
                setIsLoading(false);
            })
            .finally(() => {
                setIsLoading(false);
            })
    }

    const fetchAccessOnDrip = (query?: string) => {
        let queryString: string = "";
        if (query) {
            queryString = `?search=${query}`;
        }
        setIsLoading(true);
        CourseService.getInstance()
            .fetchAccessOnDrip(group.id, accessData.courseId, accessData.section.id, queryString)
            .then((response: any) => {
                setData(response.data);
            })
            .catch(() => {
                setIsLoading(false);
            })
            .finally(() => {
                setIsLoading(false);
            })
    }

    const loadMore = (pageNumber: any) => {
        CourseService.getInstance()
            .loadMoreStudentsOnDrip(`${data.path}?page=${pageNumber}`)
            .then((response: any) => {
                setData(response.data);
            }).catch((error: any) => console.error(error))
    }

    React.useEffect(() => {
        if (accessData.accessTitle === 'queue') {
            fetchOnQueueDrip();
        } else {
            fetchAccessOnDrip()
        }
    }, [accessData])


    return (
        <>
            <AddUsersToContentPopUp
                isOpen={accessData.isOpen}
                closePopUp={onClose}
                contentTitle={
                    `${accessData.accessTitle === 'queue'
                        ?
                        'Students in queue'
                        :
                        'Students with access'
                    } on ${accessData.section.title} section`
                }
                addMembersPopUpID={`accessData.accessTitle`}
                SearchComp={
                    <>
                        <input
                            placeholder="Search for students"
                            value={searchString}
                            onChange={e => setSearchString(e.target.value)}
                            onKeyDown={e => {
                                if (e.key === "Enter") {
                                    accessData.accessTitle === 'queue'
                                        ?
                                        fetchOnQueueDrip(searchString)
                                        :
                                        fetchAccessOnDrip(searchString);
                                }
                            }}
                        />
                        <div
                            onClick={() => {
                                accessData.accessTitle === 'queue'
                                    ?
                                    fetchOnQueueDrip(searchString)
                                    :
                                    fetchAccessOnDrip(searchString);
                            }}
                        >
                            <SearchIcon />
                        </div>
                    </>
                }
                AddActionfnComp={null}
                MemberSelection={<>
                    <>
                        {
                            !isLoading &&
                                data &&
                                data.data.length > 0
                                ?
                                <div className={styles.AccessTablePopuptable__header}>
                                    <p>Student</p>
                                    <p>Enrollment date</p>
                                </div>
                                :
                                <></>
                        }
                    </>

                </>}
                TableSection={
                    <div className={styles.AccessTablePopuptable}>
                        {
                            !isLoading &&
                                data &&
                                data.data.length > 0
                                ?
                                data.data.map((user: any, index: any) => (
                                    <>
                                        {
                                            user.user === null ?
                                                <></>
                                                :
                                    <div className={styles.AccessTablePopuptable__row} key={index}>
                                        <CustomUserComponent user={user} group={group} rightPlacement={false} />
                                        <span className={styles.AccessTablePopuptable__row__date}>{moment(user.created_at).format("MMM DD, YYYY")}</span>
                                    </div>
                                        }

                                    </>
                                ))
                                :
                                <></>
                        }
                    </div>
                }
                EmptyAndLoadingComp={
                    <>

                        <div className={styles.AccessTablePopuptable__loading}>
                            {isLoading &&
                                <>
                                    {
                                        Array(12).fill('').map((_e, i) => (
                                            <AddUsersToContentPopUpLoader key={i} />
                                        ))
                                    }
                                </>
                            }
                        </div>

                        {
                            !isLoading &&
                                data &&
                                data.data.length === 0 ?
                                <div className={styles.AccessTablePopupnoResults}>
                                    <h3>No results found</h3>
                                    <p>Please try another search</p>
                                </div>
                                :
                                <></>
                        }
                    </>
                }
                PaginationComp={
                    <>
                        {
                            !isLoading &&
                                data &&
                                data.data.length > 0
                                ?
                                <div className={styles.AccessTablePopuppagination}>
                                    <PaginationDropdown
                                        currentPage={data.current_page}
                                        lastPage={data.last_page}
                                        onPageChanged={(page: any) => loadMore(page)}
                                    />
                                </div>
                                :
                                <></>
                        }
                    </>
                }
            />
        </>
    )
}


export const AddUsersToContentPopUpLoader = () => {
    return (
        <ContentLoader
            height={70}
            width={550}
            speed={2}
            primaryColor="#d9d9d9"
            secondaryColor="#ecebeb"
        >
            <circle cx="25" cy="40" r="25" />
            <rect x="60" y="30" rx="6" ry="6" width={200} height="20" />
            <rect x="380" y="30" rx="6" ry="6" width={120} height="20" />
        </ContentLoader>
    );
}
export default AccessTablePopup